import { useContextState } from "../../../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()

  const sharedStyles = {
    squareButton: {
      color: colors.color5,
      borderRadius: '50%',
      boxShadow: `1px 1px 2px ${colors.color10}`,
      padding: '12px',
      maxHeight: '45px',
      maxWidth: '45px',
      background: colors.color30,
      '&:hover': {
        background: colors.color30 + 'dd',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.7rem',
      },
      marginRight: '-5px'
      //marginBottom: '2px',
    },
    flexBasic: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    errorAmount: {
      fontSize: '11px',
      color: colors.color19,
    },
  }

  const getColor = (status: number) => {
    let color;

    switch (status) {
      case 2:
        color = colors.color1
        break;
      case 3:
        color = colors.color12
        break;
      case 4:
        color = colors.color8
        break;
      case 5:
        color = colors.color20
        break;
    }

    return color;
  }

  return {
    userContainer: {
      padding: 3,
      position: 'relative'
    },
    butonAdder: {
      display: 'flex',
      justifyContent: 'end'
    },
    add: {
      fontSize: '2.4rem',
      color: colors.color1,
      padding: '6px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    description2: {
      '&.MuiTypography-root': {
        wordBreak: "break-word",
        overflowWrap: "break-word",
        whiteSpace: "normal",
      }
    },
    seeMore: {
      textDecoration: 'underline',
      color: colors.color10,
      fontSize: '12px',
      '& .MuiSvgIcon-root': {
        fontSize: '14px',
        transform: 'rotate(90deg)'
      },
      '&:hover': {
        textDecoration: 'underline',
      },
      '&.MuiButton-root': {
        padding: '0px',
      }
    },
    containerTitleSolution: {
      display: 'flex',
      alignItems: 'center',
    },
    position: (status: number) => ({
      backgroundColor: getColor(status),
      color: colors.color5,
      fontWeight: 'bold',
      height: '50px',
      width: '50px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      right: '0px',
      top: '0px',
      borderRadius: '0px 4px 0px 4px'
    }),
    header: (flag: boolean) => ({
      display: flag ? 'flex' : 'block',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& .dspAndGp': {
        display: 'flex',
        gap: 2
      }
    }),
    headerAndIcon: (status: number) => ({
      display: 'flex',
      gap: 1,
      alignItems: 'center',
      '& .MuiSvgIcon-root': {
        color: getColor(status)
      }
    }),
    title: (status: number) => ({
      color: getColor(status),
      fontWeight: 'bold'
    }),
    description: {
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      marginTop: 1,
      marginBottom: 1
    },
    badge: {
      marginRight: '10px',
      '& .MuiBadge-badge': {
        background: colors.color20,
        color: colors.color25,
      },
    },
    clip: {
      ...sharedStyles.squareButton,
    },
    buttonsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
      gap: 1
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '90vh',
    },
    bodyContainer: {
      flex: 1,
      overflow: 'auto',
      scrollbarWidth: 'none',
      padding: '0px 2px'
    },
  }
}

export { useStyles }
